module.exports = __webpack_public_path__ + "27d8ca49197f90010475d2b3646ce6b5.svg";